<form [formGroup]="printForm" soho-busyindicator class="csv-action-form"  [ngClass]="{'form-layout-compact': useCompactFormLayout}">
  <div *ngIf="useTabs; then TAB_CONTENT; else NON_TAB_CONTENT"></div>
  <ng-template #TAB_CONTENT>
  <div *ngIf="true then CONTEXT_FORM"></div>
  <div soho-tabs>
    <div soho-tab-list-container>
      <ul soho-tab-list>
        <li soho-tab [hidden]="false">
          <a soho-tab-title tabId="tabs-csv-display" data-automation-id="lm-export-to-csv-display-tab">{{'PDFDisplayTab' | translate}}</a>
        </li>
        <li soho-tab  [hidden]="!printInfo.includeRecordLimit && !printInfo.isTreeList">
          <a soho-tab-title tabId="tabs-csv-content" data-automation-id="lm-export-to-csv-content-tab">{{'PDFContentTab' | translate}}</a>
        </li>
        <li soho-tab [hidden]="!isUseAllActorGroups">
          <a soho-tab-title tabId="tabs-csv-sharing" data-automation-id="lm-export-to-csv-sharing-tab">{{'PDFSharingTab' | translate}}</a>
        </li>
        <li soho-tab [hidden]="!showAdvancedTab">
          <a soho-tab-title tabId="tabs-csv-advanced" data-automation-id="lm-export-to-csv-advanced-tab">{{'PDFAdvancedTab' | translate}}</a>
        </li>
      </ul>
    </div>
  </div>
  <div soho-tab-panel tabId="tabs-csv-display">
    <div *ngIf="true then DISPLAY_OPTIONS"></div>
  </div>
  <div soho-tab-panel tabId="tabs-csv-content">
    <div *ngIf="true then CONTENT_OPTIONS"></div>
  </div>
  <div soho-tab-panel tabId="tabs-csv-sharing">
    <div *ngIf="true then SHARING_OPTIONS"></div>
  </div>
  <div soho-tab-panel tabId="tabs-csv-advanced">
    <div *ngIf="true then ADVANCED_OPTIONS"></div>
  </div>
  </ng-template> <!--TAB_CONTENT-->
  <ng-template #NON_TAB_CONTENT>
    <div *ngIf="true then CONTEXT_FORM"></div>
    <div *ngIf="true then DISPLAY_OPTIONS"></div>
  </ng-template>   <!--NON_TAB_CONTENT-->

  <ng-template #CONTEXT_FORM>
    <div>
    <div  class="csv-tab-row">
      <div class="csv-criteria field">
        <label for="name">{{'Name' | translate}}</label>
        <input formControlName="name" type="text" id="name" data-automation-id="lm-export-to-csv-name" maxlength="40" soho-trackdirty/>
      </div>
      <div class="csv-criteria field only-alert">
        <label for="recordLimitAlert"></label>
        <span id="recordLimitAlert" soho-alert data-automation-id="lm-export-to-csv-record-limit-alert"></span>
      </div>
    </div>
    </div>
  </ng-template> <!--CONTEXT_FORM-->
  <ng-template #DISPLAY_OPTIONS>
    <div class="csv-tab-content">
      <div class="csv-tab-row">
        <div class="csv-criteria field">
          <label for="csvFormat">{{'CSVFormat' | translate}}</label>
          <select formControlName="csvFormat" soho-dropdown id="csvFormat" data-automation-id="lm-export-to-csv-format" noSearch soho-trackdirty class="dropdown-sm">
            <option *ngFor="let option of formatOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
      <div class="csv-tab-row">
        <div class="csv-criteria field">
          <label for="columnHeaderType">{{'Headers' | translate}}</label>
          <select formControlName="columnHeaderType" soho-dropdown id="columnHeaderType" data-automation-id="lm-export-to-csv-header-style" noSearch soho-trackdirty class="dropdown-sm">
            <option *ngFor="let option of columnHeaderOptions" [value]="option.value">{{option.label | translate}}</option>
          </select>
        </div>
      </div>
      <ng-container *ngIf="printForm.get('columnHeaderType').value === '1'">
        <div class="csv-tab-row">
        <label class="csv-criteria info-message">{{'HeadersNote' | translate}}</label>
        </div>
      </ng-container>


    </div>
  </ng-template> <!--DISPLAY_OPTIONS-->
  <ng-template #SHARING_OPTIONS>
    <div class="csv-tab-content">
      <div  class="csv-tab-row">
        <div class="field csv-criteria">
          <lm-lookup-basic #reportDistributionGroup data-automation-id="lm-export-to-csv-distribution-group"
                           [fieldLabel]="reportDistGroupLabel"
                           [sourceField]="sourceFieldName"
                           (onLookupValueChangedEvent) = "reportDistributionGroupChanged($event)">
          </lm-lookup-basic>
        </div>
        <div class="field csv-criteria" [hidden]="!showDynamicActors">
          <label soho-label for="dynamicActors"
                 [required]="atLeastOneDynamicActor">{{dynamicActorsLabel}}</label>
          <lm-list-dropdown #dynamicActorsComponent id="dynamicActors" data-automation-id="lm-export-to-csv-dynamic-actors"
                            [options]="dynamicActorOptions" soho-alert></lm-list-dropdown>
        </div>
      </div>
    </div>
  </ng-template> <!--SHARING_OPTIONS-->
  <ng-template #CONTENT_OPTIONS>
    <div class="csv-tab-content">
      <div class="csv-tab-row" *ngIf="printInfo.includeRecordLimit">
        <div class="csv-criteria field">
          <label soho-label for="recordLimitOption">{{'PDFCSVRecordLimit' | translate}}</label>
          <select formControlName="recordLimitOption" soho-dropdown id="recordLimitOption" data-automation-id="lm-export-to-csv-record-limit-option" noSearch soho-trackdirty class="dropdown-md">
            <option [value]="'default'">{{'PDFDefaultRecordsOption' | translate}}</option>
            <option [value]="'all'">{{'PDFAllRecordsOption' | translate}}</option>
            <option [value]="'large'">{{'PDFLargeRecordsOption' | translate}}</option>
            <option [value]="'small'">{{'PDFSmallRecordsOption' | translate}}</option>
            <option [value]="'custom'">{{'PDFCustomRecordsOption' | translate}}</option>
          </select>
        </div>
        <div class="csv-criteria field" *ngIf="showMaxRows">
          <label soho-label for="maxRows"></label>
          <input formControlName="maxRows" #maxRows soho-spinbox data-options="{ min:0, step:100 }" [max]="excelRowLimit" soho-trackdirty id="maxRows" data-automation-id="lm-export-to-csv-record-max-rows" class="input-sm"/>
        </div>
      </div>
      <div  class="csv-tab-row" *ngIf="(includeExportOption || detailList.length > 0)">
        <div class="csv-criteria field">
          <label soho-label for="exportOption">{{'ExportOptions' | translate}}</label>
          <select formControlName="exportOption" soho-dropdown id="exportOption" data-automation-id="lm-export-to-csv-print-option" noSearch soho-trackdirty class="dropdown-md" (change)="getDetailOptions()">
            <option *ngFor="let option of exportOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
        <div class="csv-criteria field" *ngIf="printInfo.isTreeList && showMaxLevels">
          <label soho-label for="maxLevels"></label>
          <input formControlName="maxLevels" #maxLevels soho-spinbox min="1" max="99" soho-trackdirty id="maxLevels" data-automation-id="lm-export-to-csv-max-levels" class="input-sm"/>
        </div>
        <div class="csv-criteria field" *ngIf="showDetailList">
          <label soho-label for="detailList"></label>
          <select formControlName="detailList" soho-dropdown id="detailList" data-automation-id="lm-export-to-csv-detail-list" noSearch soho-trackdirty class="dropdown-mm">
            <option *ngFor="let option of detailList" [value]="option.name">{{option.title}}</option>
          </select>
        </div>
      </div>
      <div class="csv-criteria field top-margin" *ngIf="showSelectedRecord">
        <input formControlName="selectedRecordOnly" soho-checkbox type="checkbox" id="selectedRecordOnly" data-automation-id="lm-export-to-csv-selected-record-only" />
        <label for="selectedRecordOnly" class="checkbox-label">{{'CSVSelectedWithDetails' | translate}}</label>
      </div>
      <div  class="csv-tab-row" *ngIf="includeDetailOption">
        <div class="csv-criteria field">
          <label soho-label for="detailOption">{{'DetailsOptions' | translate}}</label>
          <select formControlName="detailOption" soho-dropdown id="detailOption" data-automation-id="lm-export-to-csv-detail-option" noSearch soho-trackdirty class="dropdown-md">
            <option *ngFor="let option of detailsOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
    </div>
  </ng-template> <!--CONTENT_OPTIONS-->
  <ng-template #ADVANCED_OPTIONS>
    <div class="csv-tab-content">
      <div class="csv-tab-row">
        <div class="csv-criteria field">
          <input formControlName="needsMultiThreading" soho-checkbox type="checkbox" id="needMultiThreads" data-automation-id="lm-export-to-csv-need-multi-threads" />
          <label for="needMultiThreads" class="checkbox-label">{{'NeedsMultiThreading' | translate}}</label>
        </div>
      </div>
      <ng-container *ngIf="showMultiThreadInputs">
        <div class="csv-tab-row" >
          <div class="csv-criteria field">
            <label soho-label for="numberOfThreads">{{'CSVNoOfThreads' | translate}}</label>
            <input formControlName="numberOfThreads" #noOfThreads
                soho-spinbox data-options="{ min: 2, step:1, max:10 }" soho-trackdirty id="numberOfThreads"
                data-automation-id="lm-export-to-csv-number-of-threads" class="input-sm"/>
          </div>

          <div class="field csv-criteria">
            <label for="multiThreadFieldName">{{'CSVMultiThreadField' | translate}}</label>
            <select formControlName="multiThreadFieldName" soho-dropdown id="multiThreadFieldName" data-automation-id="lm-export-to-csv-multi-thread-field-name" soho-trackdirty class="dropdown-md">
              <option *ngFor="let option of multiThreadFieldNameOptions" [value]="option">{{option}}</option>
            </select>
          </div>
        </div>

        <div class="csv-tab-row">
          <div class="csv-criteria field alert-fit-content">
            <span id="multiThreadAlert" soho-alert data-automation-id="lm-export-to-csv-multi-thread-alert">{{'MultiThreadAlert' | translate}}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template> <!-- ADVANCED_OPTIONS-->
</form>
<div #modalPlaceholder></div>
